import { Component } from "@angular/core";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import { GisDataService } from "../gis-data-upload/gis-data-upload.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { OPTIONS } from "./models/common-adm-layer-list";
import { GeometryTypes } from "./models/geometry-types-list";
import { SELECTED_COLUMNS } from "../gis-data-upload/models/layer-table-column-list";
import { initialSharedModel, SharedModel } from "../shared/sharedmodel/shared.model";
import { ApiserviceService } from "../../../../src/app/apiservice.service";
import { NotificationService } from "../services/notification.service";
import { CommonfunctionService } from "../../../../src/app/services/commonfunction.service";

@Component({
  selector: "app-gis-common-adm-data-upload",
  templateUrl: "./gis-common-adm-data-upload.component.html",
  styleUrls: ["./gis-common-adm-data-upload.component.scss"],
})
export class GisCommonAdmDataUploadComponent {
  sharedModel: SharedModel = { ...initialSharedModel }; // use common variable from share model file
  commonAdmDataUploadGroup: FormGroup;
  layerListOption = OPTIONS;
  loader:boolean = true;
  geometryTypes = GeometryTypes;
  geometryCategory:[] = [];
  currentYear: number;
  startYear: number;
  selectedGeometryType
  selectedYear = new Date().getFullYear();;
  selectedColumns = SELECTED_COLUMNS;
  selectedData:[] = [];
  totalCount: number; // Total count of records
  uploadUrl:string;
  common_adm_upload_access = {
    GET: false, // Permission for GET requests
    POST: false, // Permission for POST requests
    PATCH: false, // Permission for PATCH requests
    DELETE: false, // Permission for DELETE requests
  };
  uploadedData: any;
  buttonConfig = {
    log: [
      {
        label: "Validate Log", // Label for the button
        action: (element: any) => this.downloadLogs(element, "validate"), // Function to execute on click
        style: {
          // Styling for the button
          border: "1px solid #e0e8ff",
          color: "#0033cc",
          backgroundColor: "#e0e8ff",
          hover: {
            // Hover styles
            backgroundColor: "#c0d9ff",
          },
          disabled: {
            // Disabled state styles
            color: "gray",
            backgroundColor: "#f0f0f0",
          },
        },
        class: "log-button", // CSS class for additional styling additional styling
      },
      {
        label: "Accept Log",
        action: (element: any) => this.downloadLogs(element, "accept"), // Function to execute on click
        style: {
          border: "1px solid #d0ffd0",
          color: "#007a00",
          backgroundColor: "#d0ffd0",
          hover: {
            backgroundColor: "#b0ffb0",
          },
          disabled: {
            color: "darkgray",
            backgroundColor: "#e0e0e0",
          },
        },
        class: "log-button",
      },
    ],
    action: [
      {
        label: "Accept",
        action: (element) => this.acceptOrRejectRequest(element, "accept"), // Function to accept request
        style: {
          border: "1px solid #24CB6B",
          color: "#ffffff",
          padding: "5px 10px",
          width: "100px",
          backgroundColor: "#24CB6B",
          hover: {
            backgroundColor: "#d9ffd9",
          },
        },
      },
      {
        label: "Reject",
        action: (element) => this.acceptOrRejectRequest(element, "reject"), // Function to reject request
        style: {
          border: "1px solid #FF8078",
          color: "#ffffff",
          padding: "5px 10px",
          width: "100px",
          backgroundColor: "#FF8078",
        },
      },
      // {
      //   label: "Stop Process",
      //   action: (element) => this.stopProcess(element), // Function to stop-process request
      //   style: {
      //     border: "1px solid ##ABABAB",
      //     color: "#ffffff",
      //     padding: "5px 10px",
      //     width: "150px",
      //     backgroundColor: "#ABABAB",
      //     hover: {
      //       backgroundColor: "#ffe5cc",
      //     },
      //     disabled: {
      //       color: "darkorange",
      //       backgroundColor: "#f5f5f5",
      //     },
      //   },
      // },
    ],
  };
  selectedLayer: any;
   // Method to get CSS class and color based on status code
   getStatusClass(status: any): { class: string; color: string } {
    // Mapping of status codes to classes and colors
    const StatusClassMap = {
      "-1": { class: "Invalid", color: "red" },
      "1": { class: "Valid", color: "blue" },
      "2": { class: "Accepted", color: "green" },
      "-3": { class: "Accept Invalid", color: "orange" },
      "0": { class: "Uploaded", color: "purple" },
      "-2": { class: "Rejected", color: "darkred" },
      "4": { class: "Accept-progress", color: "yellow" },
      "3": { class: "Validating", color: "gray" },
    };
    return (
      StatusClassMap[status] || { class: "status-default", color: "black" }
    );
  }
  constructor(
    private menus: AdminMenusService,
    private active: GisDataService,
    private fb: FormBuilder,
    private api: ApiserviceService,
    private notify: NotificationService,
    private fnc: CommonfunctionService // Injecting common function service
  ) {
    this.menus.setActive("commonAdmUpload");
    this.active.setActive("");
    this.currentYear = new Date().getFullYear();
    this.startYear = 2009;
  }
  ngOnInit(): void {
    this.getAllowResourcesApi()
  }
   // getting allow resources
   getAllowResourcesApi() {
    this.api.getUserRole();
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    this.api.getUmsData(body).subscribe((res: any) => {
      this.api.allowResources = res.data;
      this.getAllowResource();
    });
  }

  getAllowResource() {
    this.common_adm_upload_access =
      this.fnc.checkResourceAccess("common_adm");
      this.inIt()
  }
  inIt() {
    const defaultLayer = this.layerListOption?.[0].value;

    this.commonAdmDataUploadGroup = this.fb.group({
      layer: [defaultLayer, Validators.required],
      geometryTypes: [this.selectedGeometryType, Validators.required]
    });

    if (defaultLayer) {
      this.updateGeometryTypes(defaultLayer);
      this.fetchUploadStatus(); // fetch for default layer
    }
    this.commonAdmDataUploadGroup.get('layer')?.valueChanges.subscribe((selectedLayer) => {
      this.updateGeometryTypes(selectedLayer);
      this.fetchUploadStatus(); // fetch every time layer changes
    });
  }
  afterUpload(){
    this.resetPagination();
    this.fetchUploadStatus();
  }

  updateGeometryTypes(layer: any = null) {
    this.selectedLayer = layer;
      const defaultGeometryType = this.geometryTypes?.[0].value || null;

      this.commonAdmDataUploadGroup.patchValue({
        geometryTypes: defaultGeometryType
      });
    // });
  }
  onSelectionChange(selectedValue:any){
    this.selectedGeometryType = selectedValue;
    console.log('Selected:', selectedValue);
    this.fetchUploadStatus()
  }
  getUploadUrl = (): string => {
    let url = `${this.commonAdmDataUploadGroup.value.layer}/common-adm-upload?geometry_type=${this.selectedGeometryType}&added_by=${this.api.user_id}`;
    return url;
  }
  initValidators(event){
    this.fetchUploadStatus()
  }
    // Method to handle pagination changes
    onPageChange(event: any) {
      this.sharedModel.limit = event.limit; // Update limit based on pagination event
      this.sharedModel.offset = event.offset; // Update offset based on pagination event
      this.fetchUploadStatus()
    }
 resetPagination(){
  this.sharedModel.limit = 10;
  this.sharedModel.offset = 0;
  this.fetchUploadStatus()
 }
   // Handles the chosen year for the date picker
   handleYearSelected(year: number) {
    this.selectedYear = year;
    console.log(this.selectedYear);
    this.resetPagination();
    // this.fetchUploadStatus()
  }

  fetchUploadStatus() {
    // const layer = this.commonAdmDataUploadGroup.value.layer.value;
    const apiUrl = `${this.selectedLayer}/common-adm-upload/status?is_count=true&limit=${this.sharedModel.limit}&offset=${this.sharedModel.offset}&year=${this.selectedYear}&geometry_type=${this.selectedGeometryType}`;
    this.loader = true;
    this.api.getGmusData(apiUrl).subscribe({
      next: (response:any) => {
        this.loader = false;
        if(response.status == 200){
          console.log('Upload Status:', response);
        this.uploadedData = response.data
        this.totalCount = response.totalCount
        // Handle response
        }else{
          this.uploadedData = [];
            this.totalCount = response.totalCount
        }

      },
      error: (error) => {
        console.error('Error fetching status:', error);
        this.loader = false;
        this.uploadedData = [];
      }
    });
  }
  acceptOrRejectRequest(row: any, action: 'accept' | 'reject'): void {
    if (!this.common_adm_upload_access.PATCH) {
      this.notify.notify(
        "Access declined: You are not authorized to update data.",
        "warn"
      );
      return;
    }

    this.sharedModel.loader = true;

    // Construct dynamic API URL
    const layer = this.commonAdmDataUploadGroup.value.layer; // fallback if no layer in row
    let geometry_type = this.commonAdmDataUploadGroup.value.geometryTypes.value
    const uploadId = row.upload_id;
    const userId = this.api.user_id;
    let url = '';

    if (action === 'accept') {
      url = `layer=${layer}/common-adm-upload/${uploadId}/accept?geometry_type=${this.selectedGeometryType}&accepted_by=${userId}`;
    } else if (action === 'reject') {
      url = `${layer}/common-adm-upload/${uploadId}/reject?rejected_by=${userId}`;
    }
    this.loader = true;
    this.api.postGmusData(url, {}).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.notify.notify(res.message, "success");
        this.fetchUploadStatus();
      },
      error: (err) => {
        this.loader = false;
      },
    });
  }


  downloadLogs(element, action) {
    console.log(element);

    // Method to download logs based on selected row and action type

    // Check if the code is running in the browser
    // if (isPlatformBrowser(this.platformId)) {
    // Construct URL for log download based on action type
    const url =
      action === "validate"
        ? `${element.logfile_link}` // URL for validate log
        : `${element.accept_errfile_link}`; // URL for accept log
    window.open(`${url}`, "_blank"); // Open the log URL in a new browser tab
  }
}
